const phoneNumberView = (str) => {
    const regx = /^\+972/
    const isHe = regx.test(str)
    return isHe ? str.replace(regx, '0').replace(/\s/, '') : str
}

export default phoneNumberView
